export const events = {
  // Navigation
  goToTicketing: 'Go to ticketing',
  goToTicketingInsights: 'Go to ticketing insights',

  // Ticket creation
  openCreateTicketDialog: 'Open create ticket dialog',
  createTicket: 'Create ticket',

  // Ticket detail & updates
  openTicketDetail: 'Open ticket detail',
  updateTicketStatus: 'Update ticket status',
  updateTicketPriority: 'Update ticket priority',
  updateTicketAssigneeTeam: 'Update ticket assignee team',
  updateTicketAssigneeMember: 'Update ticket assignee member',

  // Comments & attachments
  addTicketComment: 'Add ticket comment',
  addTicketAttachment: 'Add ticket attachment',
  downloadTicketAttachment: 'Download ticket attachment',

  // List interactions
  filterTickets: 'Filter tickets',
  searchTickets: 'Search tickets',
  selectTicketPreset: 'Select ticket preset',
  sortTickets: 'Sort tickets',

  // Insights
  changeInsightsTeamFilter: 'Change insights team filter',
  changeInsightsPeriodFilter: 'Change insights period filter',
}
